import { GetServerSideProps, NextPage } from 'next'
import parse from 'urlencoded-body-parser'
import { LoadingDots } from '@chegg-wt/core/components/LoadingDots'
import useCiteFormRedirect from '@chegg-wt/core/hooks/useCiteFormRedirect'
import { trackWithoutThrow } from '@chegg-wt/core/utils/errors'

interface CiteFormPageProps {
  rawCiteFormData: string
}

const CiteFormPage: NextPage<CiteFormPageProps> = ({ rawCiteFormData }) => {
  useCiteFormRedirect(rawCiteFormData, true)

  return <LoadingDots message="Loading citation form" />
}

export const getServerSideProps: GetServerSideProps<CiteFormPageProps> = async ({
  req,
}) => {
  let rawBody = null
  if (req.method === 'POST') {
    try {
      rawBody = await parse(req)
      rawBody.data = decodeURIComponent(rawBody.data.replace(/\+/g, ' '))
    } catch (err) {
      trackWithoutThrow(err)
    }
  }
  return {
    props: {
      rawCiteFormData: rawBody?.data ?? null,
    } as CiteFormPageProps,
  }
}

export default CiteFormPage
